import { listItemButtonClasses, listItemTextClasses } from '@mui/material';

import type { SxProp } from 'src/types/mui';

export const containerStyles: SxProp = theme => ({
  backgroundColor: '#fff',
  display: 'grid',
  gridTemplateColumns: '3fr 9fr',
  height: '100%',
  '& > div': {
    overflow: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    display: 'block',
  },
});

export const sidebarContainerStyles: SxProp = theme => ({
  borderRightStyle: 'solid',
  borderRightWidth: '1px',
  borderRightColor: '#d2d2d2',
  [theme.breakpoints.down('sm')]: {
    borderRight: 'none',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
    borderBottomColor: '#d2d2d2',
  },
});

export const userInfoBlockStyles = {
  position: 'relative',
  paddingTop: 3,
  paddingBottom: 2,
  px: 4,
  display: 'grid',
  justifyItems: 'center',
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  borderBottomColor: '#d2d2d2',
};

export const avatarStyles: SxProp = {
  width: 100,
  height: 100,
};

export const nameStyles: SxProp = {
  textAlign: 'center',
  fontWeight: 500,
  marginTop: 1,
};

export const subtitleStyles: SxProp = {
  textTransform: 'uppercase',
};

export const menuItemsListStyles: SxProp = {
  borderBottomStyle: 'none',
};

export const menuListItemStyles: SxProp = theme => ({
  paddingX: 1,
  paddingY: 0,
  color: theme.palette.slate?.[300],
  [` .${listItemTextClasses.root}`]: {
    color: 'black',
  },
  [` .${listItemButtonClasses.root}`]: {
    borderRadius: '8px',
  },
  [` .${listItemButtonClasses.divider}`]: {
    display: 'none',
  },
  [`.${listItemButtonClasses.selected}`]: {
    [` .${listItemTextClasses.root}`]: {
      color: 'text.primary',
    },
  },
});

export const menuListItemIconStyles: SxProp = {
  marginRight: '32px',
  fontSize: '24px',
};

export const contentContainerStyles: SxProp = theme => ({
  [theme.breakpoints.down('sm')]: {
    padding: 2,
  },
});

export const settingsButtonContainerStyles: SxProp = theme => ({
  position: 'absolute',
  top: theme.spacing(1),
  right: theme.spacing(1),
});
